document.addEventListener('DOMContentLoaded', function () {
  var cart = document.querySelector('form.cart');
  if (!cart) return;
  var quantities = cart.querySelectorAll('.cart__quantity-selector');
  quantities.forEach(function (input) {
    input.setAttribute('max', '99');
    input.setAttribute('inputmode', 'numeric');
    input.addEventListener('change', function () {
      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      if (value > 99) value = 99;
      input.value = value;
      var updateButton = cart.querySelector('button[name="update"]');
      if (updateButton) updateButton.click();
      else cart.submit();
    });
  });
});